import React from 'react'
import Title from '../atoms/Title'

export default function Sectiontitle({title}) {
  return (
    <div className='h-1/6 flex justify-start items-center ms-[25px] '>
                  <div className='pb-[8px]'>

                     <Title primary>{title}</Title>
                  </div>  
                <div className="h-[3px] w-2/6 md:w-4/6 bg-[#F5F5F5] mx-[10px] md:mx-[20px] lg:mx-[80px]"></div>
    </div>
  )
}
